var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuBillPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8664_5309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2057 20.5714H7.40978C6.89018 20.5714 6.39185 20.3708 6.02443 20.0135C5.65701 19.6563 5.4506 19.1718 5.4506 18.6667V5.33334C5.4506 4.82816 5.65701 4.34368 6.02443 3.98647C6.39185 3.62925 6.89018 3.42857 7.40978 3.42857H14.2669L19.1649 8.19048V18.6667C19.1649 19.1718 18.9585 19.6563 18.5911 20.0135C18.2236 20.3708 17.7253 20.5714 17.2057 20.5714Z",
    fill: "white",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 3.42857V7.54286C14.022 7.81565 14.1123 8.07727 14.2731 8.27017C14.4338 8.46306 14.6518 8.57143 14.8792 8.57143H18.3077",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02203 7.71429H9.73631",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02203 12H15.7363",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02203 16.2857H11.4506",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8664_5309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.307739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuBillPay);
export default __webpack_public_path__ + "static/media/ic-menu-bill-pay.bd58401cdc88813413e9f5ed5e217194.svg";
export { ForwardRef as ReactComponent };